export default __webpack_public_path__ + "static/media/LECLERC_01.3bd6fa92.gif";